module.exports = __webpack_public_path__ + "img/be.ac7fdfa6.svg";